var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstantResponses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 24H48C48 37.234 37.234 48 24 48C14.42 48 5.786 42.274 2 33.59V42H0V33.018C0 31.354 1.354 30 3.016 30H12V32H3.518C6.8 40.4 14.932 46 24 46C36.13 46 46 36.13 46 24ZM46 6V14.41C42.214 5.726 33.58 0 24 0C10.766 0 0 10.766 0 24H2C2 11.87 11.87 2 24 2C33.068 2 41.2 7.6 44.482 16H36V18H44.984C46.648 18 48 16.646 48 14.982V6H46ZM30 13V18H33C34.654 18 36 19.346 36 21V35.682C36 36.962 34.958 38 33.68 38C33.246 38 32.816 37.876 32.44 37.636L27.94 34H18V26.67L15.656 28.568C15.184 28.874 14.754 29 14.32 29C13.04 29 12 27.96 12 26.682V13C12 11.346 13.346 10 15 10H27C28.654 10 30 11.346 30 13ZM18 24.088V21C18 19.346 19.346 18 21 18H28V13C28 12.45 27.552 12 27 12H15C14.448 12 14 12.45 14 13V26.682C14 26.898 14.192 27 14.32 27L18 24.088ZM33 20H21C20.448 20 20 20.45 20 21V32H28.648L33.604 36.014C33.81 36 34 35.898 34 35.682V21C34 20.45 33.552 20 33 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantResponses);
export default __webpack_public_path__ + "static/media/instantResponses.5f86182677a090331ea314c0a7b4ce2d.svg";
export { ForwardRef as ReactComponent };